import React, { useState, useEffect, useRef } from 'react';
import { STAGGING_BACKEND, LOCAL_BACKEND } from "../../../common/helper";

const MoaSearchDropdown = ({onMoaSelect}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedMoa, setSelectedMoa] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [moas, setMoas] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const dropdownRef = useRef(null);
    
    const apiUrl = STAGGING_BACKEND + "cancer/questionair/get-filtered-items/";

    useEffect(() => {
        const storedMechanism = JSON.parse(localStorage.getItem('selectedMechanism'));
        if (storedMechanism) {
          setSelectedMoa(storedMechanism.value);
          setSearchTerm(storedMechanism.label);
        }
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (searchTerm && showDropdown) {
            const debounceTimeout = setTimeout(() => {
                setIsSearching(true);
                const requestOptions = {
                    method: "GET",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: "token " + localStorage.getItem("token"),
                    }}
                fetch(`${apiUrl}?filter=unique_moa&query=${encodeURIComponent(searchTerm)}`, requestOptions)
                    .then(response => response.json())
                    .then(data => {
                        setMoas(data.data);
                        setIsSearching(false);
                    })
                    .catch(error => {
                        console.error('Error fetching cities:', error);
                        setIsSearching(false);
                    });
            }, 300); // Debounce time

            return () => clearTimeout(debounceTimeout);
        } else {
            setMoas([]);
        }
    }, [searchTerm, apiUrl, showDropdown]);

    const handleMoaSelect = (moa) => {
        setSelectedMoa(moa.value);
        setSearchTerm('');
        setShowDropdown(false);
        onMoaSelect(moa);
        localStorage.setItem('selectedMechanism', JSON.stringify(moa)); 
    };
    console.log("Mechanism of action: ", selectedMoa)

    return (
        <div ref={dropdownRef} style={{ position: 'relative', zIndex: 20 }}>
            <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{ cursor: 'pointer', padding: '5px', border: '1px solid #ccc' }}
            >
                {<input
                    type="text"
                    placeholder="Search Mechanism Of Actions"
                    value={selectedMoa || searchTerm}
                    className='cityInput'
                    onChange={(e) => {
                        setSelectedMoa(null)
                        setSearchTerm(e.target.value)}}
                    style={{ width: '100%', padding: '10px', margin: '0', boxSizing: 'border-box', backgroundColor:'white' }}
                />}
            </div>
            {showDropdown && (
                <div style={{
                    
                    width: '100%',
                    zIndex: 3,
                    maxHeight: '200px', // Fixed height
                    overflowY: 'auto', // Enable scrolling
                    backgroundColor: '#fff', // Background color for visibility
                    border: '1px solid #ccc', // Border for dropdown
                    borderTop: 'none' // Remove border top to blend with the input field
                }}>
                    {isSearching && <div>Searching...</div>}
                    <ul style={{ listStyle: 'none', padding: '0', margin: '0' }}>
                        {moas.map(moa => (
                            <li
                                key={moa.id}
                                onClick={() => handleMoaSelect(moa)}
                                style={{ padding: '10px', borderBottom: '1px solid #ccc', cursor: 'pointer' }}
                            >
                                {moa.label}
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default MoaSearchDropdown;

